import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 95006401 },
  { year: 2011, value: 81051278 },
  { year: 2012, value: 96873604 },
  { year: 2013, value: 92128370 },
  { year: 2014, value: 92621566 },
  { year: 2015, value: 84208675 },
  { year: 2016, value: 75079782 },
  { year: 2017, value: 68030637 },
  { year: 2018, value: 60065755 },
  { year: 2019, value: 56657127 },
  { year: 2020, value: 25031635 },
  { year: 2021, value: 28770174 },
  { year: 2022, value: 21197151 },
  { year: 2023, value: 20316325 },
  { year: 2024, value: 19103740 },
  { year: 2025, value: 16245978 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er T\u00e9rmino)' },
  { year: 2017, label: 'JOH Anuncia Reelecci\u00f3n' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageMedioPrensa() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/medio-radio')}>
            &#8592; Radio
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Prensa</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Prensa &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/medio-ooh')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#f87171" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageMedioPrensa;
